module.exports = __webpack_public_path__ + "img/B0A2A8_866A63_E8E9F2_614C4F-256px.4402a1d0.png";